import { cn } from '@/lib/utils';
import { AXIS_FROM_TOP_PX } from './scale';

export interface AxisEndLabelProps {
  /** Offset readout for this end of the window, e.g. "T+0:00". */
  offsetLabel: string;
  /** Hour-floored clock readout, e.g. "18:00 UTC". */
  clockLabel: string;
  /** Which end of the track this caps — drives which way the text aligns. */
  align: 'start' | 'end';
}

/**
 * One end-cap for the track, sitting beside it (not below) and vertically
 * centered on the timeline's horizontal axis.
 *
 * Measured *down from the top* (`AXIS_FROM_TOP_PX`) rather than up from the
 * bottom: the column beside this one carries the selected hour's readout
 * below the track, so the row's bottom edge is no longer a fixed distance
 * from the axis, while its top edge is. The margin drops the text's top
 * edge onto the axis and the 50% self-translate (a transform, so it costs
 * no layout) pulls it back up until its *center* lands there instead.
 */
export function AxisEndLabel({ offsetLabel, clockLabel, align }: AxisEndLabelProps) {
  return (
    <div className="flex shrink-0 flex-col">
      <span
        className={cn(
          'flex -translate-y-1/2 flex-col whitespace-nowrap font-mono text-[0.692em] text-(--scrubber-label) [text-shadow:var(--scrubber-halo)]',
          align === 'start' ? 'items-start' : 'items-end',
        )}
        style={{ marginTop: `${AXIS_FROM_TOP_PX}px` }}
      >
        <span>{offsetLabel}</span>
        <span className="text-(--scrubber-label)/70">{clockLabel}</span>
      </span>
    </div>
  );
}
